import { render, staticRenderFns } from "./CheckoutModal.vue?vue&type=template&id=3b1bd5dd"
import script from "./CheckoutModal.vue?vue&type=script&lang=js"
export * from "./CheckoutModal.vue?vue&type=script&lang=js"
import style0 from "./CheckoutModal.vue?vue&type=style&index=0&id=3b1bd5dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports